import { createContext, Dispatch, ReactNode, SetStateAction, useMemo, useState } from 'react';

interface TabIds {
  tabId: string;
  panelId: string;
}

interface LayoutContextType {
  selectedTabIds: TabIds | null;
  setSelectedTabIds: React.Dispatch<React.SetStateAction<TabIds | null>>;
  isCommentsPanelOpen: boolean;
  setIsCommentsPanelOpen: Dispatch<SetStateAction<boolean>>;
  isCommentsPanelExpanded: boolean;
  setIsCommentsPanelExpanded: Dispatch<SetStateAction<boolean>>;
}

export const LayoutContext = createContext<LayoutContextType>({
  selectedTabIds: null,
  setSelectedTabIds: () => {},
  isCommentsPanelOpen: false,
  setIsCommentsPanelOpen: () => {},
  isCommentsPanelExpanded: false,
  setIsCommentsPanelExpanded: () => {},
});

interface Props {
  children: ReactNode;
}

const useLayoutContextProviderVM = () => {
  const [selectedTabIds, setSelectedTabIds] = useState<TabIds | null>(null);
  const [isCommentsPanelOpen, setIsCommentsPanelOpen] = useState(false);
  const [isCommentsPanelExpanded, setIsCommentsPanelExpanded] = useState(false);

  return useMemo<LayoutContextType>(
    () => ({
      selectedTabIds,
      setSelectedTabIds,
      isCommentsPanelOpen,
      setIsCommentsPanelOpen,
      isCommentsPanelExpanded,
      setIsCommentsPanelExpanded,
    }),
    [selectedTabIds, isCommentsPanelOpen, isCommentsPanelExpanded]
  );
};

const LayoutContextProvider = ({ children }: Props) => {
  const providerValue = useLayoutContextProviderVM();

  return <LayoutContext.Provider value={providerValue}>{children}</LayoutContext.Provider>;
};

export default LayoutContextProvider;
